import {Button} from '@superweb/ui'
import {useI18n} from '@yandex-delivery/core/i18n'
import React from 'react'

import type {Resource} from '../../../../../../utils'

export type DownloadButtonProps = {
  fileResource?: Resource<boolean>
} & React.ComponentProps<typeof Button>

export function DownloadButton({fileResource, ...buttonProps}: DownloadButtonProps) {
  fileResource?.read()

  const i18n = useI18n()

  return (
    <Button
      size="s"
      text={buttonProps.text || i18n('tariffs-v3.tariff-info.download-button', 'Скачать файлом')}
      view="action"
      {...buttonProps}
    />
  )
}
